package gr.tech.GRAttestation.styles.user

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import gr.tech.GRAttestation.util.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

val accountManagementStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(16.px)
    }
    Breakpoint.MD {
        Modifier
            .width(400.px)
    }
}

val profileInformationStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(16.px)
            .borderTop(2.px, LineStyle.Solid, Colors.DarkGrey)
            .borderLeft(2.px, LineStyle.Solid, Colors.Transparent)
    }
    Breakpoint.MD {
        Modifier
            .width(900.px)
            .borderLeft(2.px, LineStyle.Solid, Colors.DarkGrey)
            .borderTop(2.px, LineStyle.Solid, Colors.Transparent)
    }
}

val profileHeaderTitleStyle = CssStyle {
    base {
        Modifier
            .fontFamily(FONT_FAMILY)
            .fontWeight(FontWeight.Bold)
            .fontSize(1.15.cssRem)
            .margin(0.px)
    }
}

val profileInputLabelStyle = CssStyle {
    base {
        Modifier
            .fontFamily(FONT_FAMILY)
            .fontWeight(FontWeight.Medium)
            .fontSize(1.cssRem)
            .margin(
                leftRight = 6.px,
                topBottom = 6.px
            )
    }
}

val profileInputStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .height(44.px)
            .border(1.px, LineStyle.Solid, Colors.DarkGrey)
            .borderRadius(5.px)
            .fontFamily(FONT_FAMILY)
            .fontSize(1.cssRem)
            .padding(left = 4.px)
            .color(Colors.Black)
    }
}

val profileRowStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(16.px)
    }
}